import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-sm-9" }
const _hoisted_4 = { class: "col-sm-3" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-0 mb-4" }, null, -1)
const _hoisted_7 = { class: "table table-striped" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { colspan: "2" }
const _hoisted_10 = { class: "d-flex align-items-center py-3" }
const _hoisted_11 = {
  key: 0,
  class: "ms-1 fs_14"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("sub", { class: "custom-px-2 custom-fs-10" }, "2", -1)
const _hoisted_13 = {
  key: 1,
  class: "ms-1 fs_14"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("sub", { class: "custom-px-2 custom-fs-10" }, "2", -1)
const _hoisted_15 = { class: "row mt-5 mb-3" }
const _hoisted_16 = { class: "col-sm-3 mb-3" }
const _hoisted_17 = { class: "card" }
const _hoisted_18 = { class: "card-body text-center" }
const _hoisted_19 = { class: "fw_700 my-2" }
const _hoisted_20 = {
  key: 0,
  class: "custom-fs-14",
  style: {"color":"#666"}
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("sub", { class: "custom-px-2 custom-fs-10" }, "2", -1)
const _hoisted_22 = {
  key: 1,
  class: "custom-fs-14",
  style: {"color":"#666"}
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("sub", { class: "custom-px-2 custom-fs-10" }, "2", -1)
const _hoisted_24 = { class: "card" }
const _hoisted_25 = { class: "card-body text-center" }
const _hoisted_26 = { class: "fw_700 my-2" }
const _hoisted_27 = {
  key: 0,
  class: "custom-fs-14",
  style: {"color":"#666"}
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("sub", { class: "custom-px-2 custom-fs-10" }, "2", -1)
const _hoisted_29 = {
  key: 1,
  class: "custom-fs-14",
  style: {"color":"#666"}
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("sub", { class: "custom-px-2 custom-fs-10" }, "2", -1)
const _hoisted_31 = { class: "row mb-3" }
const _hoisted_32 = { class: "col-sm-12" }
const _hoisted_33 = { class: "card" }
const _hoisted_34 = { class: "card-body text-center" }
const _hoisted_35 = { class: "row mb-3" }
const _hoisted_36 = { class: "col-sm-8" }
const _hoisted_37 = { class: "card" }
const _hoisted_38 = { class: "card-body" }
const _hoisted_39 = { class: "table table-striped" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { colspan: "2" }
const _hoisted_42 = { class: "py-2" }
const _hoisted_43 = { class: "col-sm-4" }
const _hoisted_44 = { class: "card h-100" }
const _hoisted_45 = { class: "card-body text-center d-flex align-items-center justify-content-center" }
const _hoisted_46 = {
  key: 1,
  class: "text-center pt-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_form_field = _resolveComponent("form-field")!
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_line_chart = _resolveComponent("line-chart")!
  const _component_chart = _resolveComponent("chart")!

  return (_ctx.loaded && _ctx.availableYears.length > 1)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_form_field, {
              type: "select-string",
              list: _ctx.availableYears,
              modelValue: _ctx.selectedYear,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedYear) = $event)),
              labelKey: "Time period",
              labelValue: "Time period",
              placeholderKey: "Select a time period",
              placeholderValue: "Select a time period",
              onChange: _ctx.updateTimePeriod
            }, null, 8, ["list", "modelValue", "onChange"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_localized_text, {
              localizedKey: "Results visualization",
              text: "Results visualization",
              class: "d-block mb-2 pb-1 fw_700"
            }),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                class: _normalizeClass(["btn w-50 justify-content-center me-2", !_ctx.tonnesVisualization ? 'btn-tertiary': 'btn-secondary withBorder']),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.tonnesVisualization = false))
              }, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Kg",
                  text: "Kg"
                })
              ], 2),
              _createElementVNode("button", {
                class: _normalizeClass(["btn w-50 justify-content-center", _ctx.tonnesVisualization ? 'btn-tertiary': 'btn-secondary withBorder']),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.tonnesVisualization = true))
              }, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Tonnes",
                  text: "Tonnes"
                })
              ], 2)
            ])
          ])
        ]),
        _hoisted_6,
        _createElementVNode("table", _hoisted_7, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Scope",
                  text: "Scope"
                })
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.years, (year) => {
                return (_openBlock(), _createElementBlock("td", { key: year }, _toDisplayString(year), 1))
              }), 128))
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_ctx.scope1ResumeData.tableValues.length == 0)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [
                  _createElementVNode("td", _hoisted_9, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "No Elements Found",
                      text: "No Elements Found"
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.scope1ResumeData.tableValues.filter(x => x.name.indexOf('Scope-01') > -1) as OM.GHGInventoryDataVM[]), (item, i) => {
              return (_openBlock(), _createElementBlock("tr", { key: i }, [
                _createElementVNode("td", null, _toDisplayString(item.name), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.years, (year) => {
                  return (_openBlock(), _createElementBlock("td", { key: year }, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$filters.currency(_ctx.$utils.getEmissionValue(_ctx.getValueForYear(item.valuesPerYear, year), _ctx.tonnesVisualization))), 1),
                      (!_ctx.tonnesVisualization)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                            _createTextVNode("(Kg CO"),
                            _hoisted_12,
                            _createTextVNode("e)")
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_13, [
                            _createTextVNode("(Tonnes CO"),
                            _hoisted_14,
                            _createTextVNode("e)")
                          ]))
                    ])
                  ]))
                }), 128))
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Total GHG Emissions",
                  text: "Total GHG Emissions",
                  class: "fw_700"
                }),
                _createElementVNode("h4", _hoisted_19, _toDisplayString(_ctx.$filters.currency(_ctx.$utils.getEmissionValue(_ctx.scope1ResumeData.totalEmissions, _ctx.tonnesVisualization))), 1),
                (!_ctx.tonnesVisualization)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                      _createTextVNode("(Kg CO"),
                      _hoisted_21,
                      _createTextVNode("e)")
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_22, [
                      _createTextVNode("(Tonnes CO"),
                      _hoisted_23,
                      _createTextVNode("e)")
                    ]))
              ])
            ])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scope1ResumeData.categoriesTotals, (catVal, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col-sm-3 mb-3",
              key: index
            }, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_localized_text, {
                    localizedKey: catVal.key,
                    text: catVal.key,
                    class: "fw_700"
                  }, null, 8, ["localizedKey", "text"]),
                  _createElementVNode("h4", _hoisted_26, _toDisplayString(_ctx.$filters.currency(_ctx.$utils.getEmissionValue(catVal.value, _ctx.tonnesVisualization))), 1),
                  (!_ctx.tonnesVisualization)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_27, [
                        _createTextVNode("(Kg CO"),
                        _hoisted_28,
                        _createTextVNode("e)")
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_29, [
                        _createTextVNode("(Tonnes CO"),
                        _hoisted_30,
                        _createTextVNode("e)")
                      ]))
                ])
              ])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                (_openBlock(), _createBlock(_component_line_chart, {
                  dataDictionary: _ctx.emissionsByMonth,
                  key: _ctx.lineChartKey,
                  weightLabel: _ctx.tonnesVisualization ? 'Tonnes CO2e' : 'kg CO2e'
                }, null, 8, ["dataDictionary", "weightLabel"]))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("table", _hoisted_39, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", null, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "Premises type",
                          text: "Premises type"
                        })
                      ]),
                      _createElementVNode("td", null, [
                        (_ctx.tonnesVisualization)
                          ? (_openBlock(), _createBlock(_component_localized_text, {
                              key: 0,
                              localizedKey: "Tonnes CO2e",
                              text: "Tonnes CO2e"
                            }))
                          : (_openBlock(), _createBlock(_component_localized_text, {
                              key: 1,
                              localizedKey: "Kg CO2e",
                              text: "Kg CO2e"
                            }))
                      ])
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_ctx.scope1ResumeData.premisesTotals.length == 0)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_40, [
                          _createElementVNode("td", _hoisted_41, [
                            _createVNode(_component_localized_text, {
                              localizedKey: "No Elements Found",
                              text: "No Elements Found"
                            })
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.scope1ResumeData.premisesTotals as OM.KeyValuePairOfStringAndDouble[]), (item, i) => {
                      return (_openBlock(), _createElementBlock("tr", { key: i }, [
                        _createElementVNode("td", null, _toDisplayString(item.key), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.$filters.currency(_ctx.$utils.getEmissionValue(item.value, _ctx.tonnesVisualization))), 1)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                (_openBlock(), _createBlock(_component_chart, {
                  class: "w-100",
                  summaryChartVM: _ctx.premisesPercentagePieChart,
                  legendPosition: 'bottom',
                  key: _ctx.pieChartKey
                }, null, 8, ["summaryChartVM"]))
              ])
            ])
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_46, [
        _createVNode(_component_localized_text, {
          localizedKey: "No data yet",
          text: "No data yet",
          class: "d-block mb-2 pb-1 fw_700"
        }),
        _createElementVNode("button", {
          class: "btn btn-primary",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/activity-data-recorder')))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Add new activity",
            text: "Add new activity"
          })
        ])
      ]))
}